/* tslint:disable:no-any */
import { Interface, Method } from '@central-products/transport-bus-common';
import {
  OperationVariables,
  QueryOptions,
  MutationOptions,
  WatchQueryOptions,
  ApolloQueryResult,
  ObservableQuery,
} from 'apollo-client';
import { FetchResult } from 'apollo-link';

@Interface('common', 'data.service')
export class DataAccessServiceInterface {
  @Method('client.get')
  public getClient(): Promise<any> {
    throw new Error('Method is not implemented yet');
  }

  @Method('query')
  public query<T = any, TVariables = OperationVariables>(
    _options: QueryOptions<TVariables>
  ): Promise<ApolloQueryResult<T>> {
    throw new Error('Method is not implemented yet');
  }

  @Method('mutate')
  public mutate<T = any, TVariables = OperationVariables>(
    _options: MutationOptions<T, TVariables>
  ): Promise<FetchResult<T>> {
    throw new Error('Method is not implemented yet');
  }

  @Method('watchQuery')
  public watchQuery<T = any, TVariables = OperationVariables>(
    _options: WatchQueryOptions<TVariables>
  ): ObservableQuery<T, TVariables> {
    throw new Error('Method is not implemented yet');
  }
}
